module.exports = __webpack_public_path__ + "static/media/christmasdinner.720b59df.png";